import { Box } from "@mui/material";
import VendorSelector from "./components/vendorSelector";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import { useBidContext } from "./Bid.context";
import BidEvaluationView from "./components/BidEvaluationView";
import ECSBidEvalutionView from "./components/ECSBidEvalutionView";

const MainBidTab = ({ isEcs = false }) => {
  const { mrqSelection, selectedBidVendors } = useBidContext();

  return (
    <Box>
      <Box
        display={"flex"}
        gap={1}
        sx={{ alignItems: "baseline", height: "max-content" }}
      >
        {/* No MRQ Manager selector here: the MRQ is named by the route
            (/plant/:plantId/bid/:bidId) and loaded by the context, so only
            the vendor selection sits ahead of the bid table. */}
        {mrqSelection?.selectedMrq ? (
          <LabelledBox label="Vendors">
            <VendorSelector isMultiple={true} />
          </LabelledBox>
        ) : (
          <></>
        )}
      </Box>
      {isEcs ? (
        selectedBidVendors?.length > 0 && <ECSBidEvalutionView />
      ) : (
        <BidEvaluationView />
      )}
      {/* ------------  box ! ------------------ */}
    </Box>
  );
};

export default MainBidTab;